/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonLwWeeklyBurnSourcesRequest = {
    period?: NexonLwWeeklyBurnSourcesRequest.period;
};

export namespace NexonLwWeeklyBurnSourcesRequest {

    export enum period {
        M3 = 'M3',
        M6 = 'M6',
        Y1 = 'Y1',
        ALL = 'ALL',
    }


}

